import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

/**
 * Displays an MVP statistics table
 *
 * @param {Object} props
 * @param {Array} props.data - Array of MVP stats with rank, player, team, points
 * @param {string} props.highlightUserId - User ID to highlight in the table
 */
export default function MvpStatsTable({ data = [], highlightUserId }) {
  if (!data) {
    return null;
  }
  if (data.length === 0) {
    return (
      <Typography variant="h6" gutterBottom align="center" sx={{ mt: 2 }}>
        No points available
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="h4" gutterBottom>
        MVPs
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table aria-label="mvp statistics">
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.main" }}>
              <TableCell>Rank</TableCell>
              <TableCell>Player</TableCell>
              <TableCell>Team</TableCell>
              <TableCell>Points</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => {
              const isHighlighted =
                highlightUserId && row.userId === highlightUserId;
              const isFirstPlace = row.rank === 1;
              return (
                <TableRow
                  key={row.rank || row.player}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor: isHighlighted
                      ? "rgba(25, 118, 210, 0.1)"
                      : isFirstPlace
                      ? "rgba(255, 215, 0, 0.1)"
                      : "inherit",
                    "&:hover": {
                      backgroundColor: isHighlighted
                        ? "rgba(25, 118, 210, 0.2)"
                        : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      fontWeight:
                        isFirstPlace || isHighlighted ? "bold" : "normal",
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: isHighlighted ? "bold" : "normal" }}
                  >
                    {row.playerFirstName.substring(0, 1)}. {row.playerLastName}
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: isHighlighted ? "bold" : "normal" }}
                  >
                    {row.username}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    {row.points}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
